module.exports = __webpack_public_path__ + "static/media/hidden-company-2.7807889b.svg";